export default __webpack_public_path__ + "static/media/areoplane.c31c10f1.png";